// v1.48 — when an approved bill is pushed to the accounting product for
// payment, we stamp it with a reference so the UI can show "sent for payment".
// In a real integration this ref would be the bill id returned by the
// Xero/MYOB/QuickBooks API; here it's a deterministic-looking mock.

export interface AccountingExportRecord {
  product: string;
  ref: string;
  at: string;
}

const PREFIX: Record<string, string> = {
  Xero: 'XRO',
  MYOB: 'MYOB',
  QuickBooks: 'QBO',
};

export function buildAccountingExport(product: string, billNo: string): AccountingExportRecord {
  const prefix = PREFIX[product] ?? product.slice(0, 3).toUpperCase();
  const seq = Math.floor(1000 + Math.random() * 9000);
  const num = (billNo.match(/(\d+)\s*$/)?.[1]) ?? String(seq);
  return {
    product,
    ref: `${prefix}-${num}`,
    at: new Date().toISOString(),
  };
}
